import BaseHttpService from "JS/services/BaseHttpService";
import { IBaseHttpService } from "JS/types/Http";

export interface ITrackOrderService {
	searchOrder(email: string, orderId: string): Promise<TrackOrderResponse>;
}
export type TrackOrderResponse = { 
	orderHashUrlParameter?: string,
	error?: string
}

const BASE_URL = "/account/track-your-order";
export default class TrackOrderService implements ITrackOrderService {
	constructor(private _httpService: IBaseHttpService = new BaseHttpService()) {}

	searchOrder(email: string, oid: string): Promise<TrackOrderResponse> {
		return this._httpService.post<TrackOrderResponse>(BASE_URL, {
			email,
			oid
		});
	}
}